export class CustomAnchor {
    constructor() {
        this.init();
    }

    init() {
        window.addEventListener('DOMContentLoaded', () => {
            const searchParams = new URLSearchParams(window.location.search)
            
            const target = searchParams.get('target_element')
        
            if (target) {
                window.scroll({
                    top: document.querySelector(`#${target}`)?.offsetTop,
                    left: 0,
                    behavior: "smooth",
                })
            }
        })
    }
}
